import "@/index.css";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { Toaster } from "sonner";
import HomePage from "./pages/HomePage";
import PopupPhotoPage from "./pages/PopupPhotoPage";

function App() {
  return (
    <LanguageProvider>
      <div className="App min-h-screen bg-[#050505]">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/popup-photo" element={<PopupPhotoPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster 
          position="top-right" 
          richColors 
          theme="dark"
          toastOptions={{
            style: {
              background: '#121212',
              border: '1px solid rgba(255,255,255,0.1)',
            }
          }}
        />
      </div>
    </LanguageProvider>
  );
}

export default App;
